import { CountUp } from "@/components/common/CountUp";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import { TrendingDown, TrendingUp } from "lucide-react";

interface StatCardProps {
	icon: LucideIcon;
	label: string;
	value: string | number;
	trend?: {
		value: number;
		direction: "up" | "down";
	};
}

export function StatCard({ icon: Icon, label, value, trend }: StatCardProps) {
	return (
		<div className="glass rounded-xl p-6 shadow-md">
			<div className="flex items-start justify-between">
				<div className="rounded-lg bg-accent-muted p-2.5">
					<Icon className="h-5 w-5 text-accent" aria-hidden="true" />
				</div>
				{trend && (
					<div
						className={cn(
							"flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
							trend.direction === "up"
								? "bg-success-muted text-success"
								: "bg-error-muted text-error",
						)}
					>
						{trend.direction === "up" ? (
							<TrendingUp className="h-3 w-3" aria-hidden="true" />
						) : (
							<TrendingDown className="h-3 w-3" aria-hidden="true" />
						)}
						{trend.value}%
					</div>
				)}
			</div>
			<div className="mt-4">
				<p className="text-sm text-secondary">{label}</p>
				<p className="mt-1 text-3xl font-bold text-primary">
					{typeof value === "number" ? <CountUp target={value} /> : value}
				</p>
			</div>
		</div>
	);
}
